module.exports = __webpack_public_path__ + "static/citylights-24bfa9c77282aee73d180479e2834abb.png";